import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, getFormValues } from 'redux-form';
import { CLIENT_SETTINGS, COMPANY_SHOW } from 'src/constants/EndpointUrls';
import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { REDUCER_NAME, editCompany } from 'src/reducers/clients/clients';
import CompanyForm from './components/CompanyForm';
import { setItem, getItemErrors, getItem } from 'src/reducers/common/itemReducer';
import { CLIENT_FORM } from 'src/constants/FormNames';
import { concatParamsToUrl } from 'src/utils/Http';
import { useTranslation } from 'react-i18next';

let EditCompanyForm = reduxForm({
  form: CLIENT_FORM
})(CompanyForm);

const mapStateToProps = state => ({
  isNewForm: false,
  errors: getItemErrors(REDUCER_NAME, state),
  initialValues: getItem(REDUCER_NAME, state)
});

const mapDispatchToProps = dispatch => ({
  onSubmit: data => dispatch(editCompany(data))
});

EditCompanyForm = connect(mapStateToProps, mapDispatchToProps)(EditCompanyForm);

const EditCompany = ({ dispatch, values}) => {
  dispatch(setItem(REDUCER_NAME, values));
  const { t } = useTranslation();
  const showUrl = concatParamsToUrl(COMPANY_SHOW, { id: values.client.id })
  return (
    <div className="l-wrap-xl l-contents-wrap">
      <div className="u-mb20">
        <BreadCrumb>
          <BreadCrumb.Item label={t('features.Clients.EditCompany.setting')} path={CLIENT_SETTINGS} />
          <BreadCrumb.Item label={t('features.Clients.EditCompany.edit_office_information')} />
        </BreadCrumb>
      </div>
      <EditCompanyForm {...{showUrl}} />
    </div>
  );
};

export default connect()(EditCompany);